import { render, staticRenderFns } from "./DetectionSetUpload.vue?vue&type=template&id=2d1b46f0&scoped=true&"
import script from "./DetectionSetUpload.vue?vue&type=script&lang=js&"
export * from "./DetectionSetUpload.vue?vue&type=script&lang=js&"
import style0 from "./DetectionSetUpload.vue?vue&type=style&index=0&id=2d1b46f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b46f0",
  null
  
)

export default component.exports